export default function TakeoutMenuScan(){
    return (
        <>
            <img src='scan-takeout.jpg' style={{width:'8.5in',height:'11in'}} />
        </>
    )
}